var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasestacionario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 23,
    viewBox: "0 0 9 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82302 8.12996L1.01479 20.7863C0.942199 21.2944 1.14296 21.5534 1.66391 21.6278L4.86656 22.0854C5.35894 22.1557 5.63529 21.9562 5.70314 21.4813C5.89345 20.1493 7.29591 10.333 7.48601 9.00245L7.51489 8.80029L2.82302 8.12996Z",
    stroke: "#7341B5",
    strokeWidth: 1.73629
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89581 7.65854L7.55733 8.32453C7.65234 7.65951 7.81301 7.00609 7.82277 6.34885C7.83144 5.50295 7.16375 4.81323 6.32079 4.67506C5.82274 4.59614 5.31901 4.50199 4.82032 4.50614C4.41031 4.51778 4.01775 4.6706 3.71038 4.93823C3.40302 5.20587 3.20013 5.57152 3.13676 5.97208C3.04502 6.5278 2.97747 7.08697 2.89581 7.65854Z",
    stroke: "#7341B5",
    strokeWidth: 1.73629
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3933 3.50898C7.45142 3.10218 7.16876 2.72528 6.76195 2.66716L5.65708 2.50931C5.25027 2.45119 4.87338 2.73385 4.81526 3.14065L4.71002 3.87724L7.28806 4.24557L7.3933 3.50898Z",
    fill: "#7341B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.83641,
    height: 1.11609,
    rx: 0.372031,
    transform: "matrix(-0.989947 -0.141435 -0.141435 0.989947 8.86621 1.08899)",
    fill: "#7341B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasestacionario);
export default __webpack_public_path__ + "static/media/gasestacionario.2cfcf7f3296de59a7259c2038d81e5a3.svg";
export { ForwardRef as ReactComponent };